import { createSelector } from 'reselect';
import pipe from 'ramda/es/pipe';
import values from 'ramda/es/values';
import map from 'ramda/es/map';
import prop from 'ramda/es/prop';


export default createSelector(
  [
    state => state.students.data,
  ],
  pipe(
    values,
    map(({ id, name, klass, gender, photo }) => ({
      id,
      title: prop('first', name),
      klass,
      gender,
      photo,
    }))
  )
);
